import { useFormik } from "formik"
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../../bootstrap/Modal"
import { useContext, useEffect, useState } from "react"
import FormGroup from "../../bootstrap/forms/FormGroup"
import Input from "../../bootstrap/forms/Input"
import Button from "../../bootstrap/Button"
import { DefaultContext } from "../../../contexts/default"
import PreAlert from "../../../helpers/utils/preAlert"
import IntegrationsDB from "../../../database/wrappers/integrations"
import BtnLoad from "../../MyCustom/BtnLoad"

const ModalEditIntegrations = ({ open, handleOpen, integration }) => {

    const { onShowAlert, storeSelected, estabSelected, store } = useContext(DefaultContext);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            ifood_catalog: integration?.ifood_catalog || "",
            ifood_id: integration?.ifood_id || "",
            rappi_id: integration?.rappi_id || "",
            omie_app_key: integration?.omie_app_key || "",
            omie_secret: integration?.omie_secret || "",
            store_99: integration?.store_99 || "",
            token_99: integration?.token_99 || "",
            everest: integration?.everest ?? false,
            estab_id: integration?.estab_id || estabSelected,
            store_id: integration?.store_id || storeSelected,
            store_name: store?.name || "",
            cnpj: store?.cnpj || ""
        },

        enableReinitialize: true,
        onSubmit: values => {
            setIsLoading(true);
            const {
                ifood_catalog,
                ifood_id,
                rappi_id,
                omie_app_key,
                omie_secret,
                store_99,
                token_99,
                everest
            } = values;

            const data = {
                ifood_catalog: ifood_catalog || "",
                ifood_id: ifood_id || "",
                rappi_id: rappi_id || "",
                omie_app_key: omie_app_key || "",
                omie_secret: omie_secret || "",
                store_99: store_99 || "",
                token_99: token_99 || "",
                everest: !!everest,
                estab_id: estabSelected,
                store_id: storeSelected,
                store_name: store?.name || "",
                cnpj: store?.cnpj || ""
            }

            const onSuccessUpdate = () => {
                onShowAlert(PreAlert.success('Registro atualizado com sucesso'))
                handleOpen()
            }

            const onError = () => {
                onShowAlert(PreAlert.error('Falhou no registro'))
                handleOpen()
            }

            if (integration.id) {
                new IntegrationsDB()
                    .update(integration.id, data)
                    .then(() => onSuccessUpdate())
                    .catch((e) => {
                        console.error(e)
                        onError()
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
            }
            else {
                new IntegrationsDB()
                    .define(storeSelected, data)
                    .then(() => onSuccessUpdate())
                    .catch((e) => {
                        console.error(e)
                        onError()
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
            }
        }
    })

    useEffect(() => {
        if (!open || !integration) return;

        const {
            ifood_catalog,
            ifood_id,
            rappi_id,
            omie_app_key,
            omie_secret,
            store_99,
            token_99,
            store_name,
            cnpj,
            everest
        } = integration;

        formik.setValues({
            ifood_catalog: ifood_catalog || "",
            ifood_id: ifood_id || "",
            rappi_id: rappi_id || "",
            omie_app_key: omie_app_key || "",
            omie_secret: omie_secret || "",
            store_99: store_99 || "",
            token_99: token_99 || "",
            everest: everest ?? false,
            store_name: store_name || store.name,
            cnpj: cnpj || store.cnpj
        });
    }, [integration, open]);


    return (
        <>
            <Modal
                id={'modal-edit-integrações'}
                titleId={'Modal Edit integraçoes'}
                isOpen={open}
                setIsOpen={() => handleOpen()}
                sStaticBackdrop={true}
                isScrollable={true}
                isCentered={true}
                size='lg' //'sm' // 'lg' // 'xl'
                isAnimation={true}
                onSubmit={formik.handleSubmit}
            >
                <ModalHeader setIsOpen={() => handleOpen()}>
                    <ModalTitle>Edite os dados da integração</ModalTitle>
                </ModalHeader>
                <>
                    <ModalBody className='p-5 max-h-90vh'>
                        <form noValidate onSubmit={formik.handleSubmit}>

                            {/* Seção Dados Basicos */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">Dados Basicos</h5>
                                </div>
                                <div className="row">
                                    <FormGroup id="cnpj" label="CNPJ" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.cnpj || ''}
                                            isValid={formik.isValid}
                                            validFeedback='Assim está bom!'
                                            placeholder="CNPJ"
                                            disabled
                                        />
                                    </FormGroup>
                                    <FormGroup id="store_name" label="Nome da Loja" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.store_name || ''}
                                            isValid={formik.isValid}
                                            validFeedback='Assim está bom!'
                                            placeholder="Nome da Loja"
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <hr className="my-4" />

                            {/* Seção 99Food */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">99Food</h5>
                                </div>
                                <div className="row">
                                    <FormGroup id="store_99" label="Store ID" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.store_99 || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.store_99}
                                            invalidFeedback={formik.errors.store_99}
                                            validFeedback='Assim está bom!'
                                            placeholder="ID da loja no 99Food"
                                        />
                                    </FormGroup>
                                    <FormGroup id="token_99" label="Token" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.token_99 || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.token_99}
                                            invalidFeedback={formik.errors.token_99}
                                            validFeedback='Assim está bom!'
                                            placeholder="Token de autenticação"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <hr className="my-4" />

                            {/* Seção iFood */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">iFood</h5>
                                </div>
                                <div className="row">
                                    <FormGroup id="ifood_id" label="ID iFood" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.ifood_id || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.ifood_id}
                                            invalidFeedback={formik.errors.ifood_id}
                                            validFeedback='Assim está bom!'
                                            placeholder="ID do restaurante"
                                        />
                                    </FormGroup>
                                    <FormGroup id="ifood_catalog" label="ID Catálogo" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.ifood_catalog || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.ifood_catalog}
                                            invalidFeedback={formik.errors.ifood_catalog}
                                            validFeedback='Assim está bom!'
                                            placeholder="ID do catálogo de produtos"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <hr className="my-4" />

                            {/* Seção Rappi */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">Rappi</h5>
                                </div>
                                <div className="row">
                                    <FormGroup id="rappi_id" label="ID Rappi" className='col-md-12 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.rappi_id || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.rappi_id}
                                            invalidFeedback={formik.errors.rappi_id}
                                            validFeedback='Assim está bom!'
                                            placeholder="ID do restaurante no Rappi"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <hr className="my-4" />

                            {/* Seção Omie */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">Omie</h5>
                                </div>
                                <div className="row">
                                    <FormGroup id="omie_app_key" label="App Key" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.omie_app_key || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.omie_app_key}
                                            invalidFeedback={formik.errors.omie_app_key}
                                            validFeedback='Assim está bom!'
                                            placeholder="Chave da aplicação"
                                        />
                                    </FormGroup>
                                    <FormGroup id="omie_secret" label="App Secret" className='col-md-6 mb-3'>
                                        <Input
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.omie_secret || ''}
                                            isValid={formik.isValid}
                                            isTouched={formik.touched.omie_secret}
                                            invalidFeedback={formik.errors.omie_secret}
                                            validFeedback='Assim está bom!'
                                            placeholder="Chave secreta da aplicação"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <hr className="my-4" />

                            {/* Seção Everest */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 text-dark">Everest</h5>
                                </div>

                                <FormGroup label="Ativar integração Everest">
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="everest"
                                            name="everest"
                                            checked={formik.values.everest}
                                            onChange={formik.handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="everest">
                                            {formik.values.everest ? 'Ativa' : 'Inativa'}
                                        </label>
                                    </div>
                                </FormGroup>
                            </div>

                            {/* Buttons */}
                            <div className="row pt-4">
                                <div className='d-flex justify-content-end gap-3 mt-3'>
                                    <Button
                                        color="danger"
                                        icon="cancel"
                                        rounded={1}
                                        onClick={handleOpen}
                                        shadow="sm"
                                        hoverShadow="sm"
                                        size="sm"
                                    >
                                        Cancelar
                                    </Button>

                                    {isLoading ? (
                                        <BtnLoad />
                                    ) : (
                                        <Button
                                            isDisable={!formik.isValid && !!formik.submitCount}
                                            type="submit"
                                            color="success"
                                            icon="check"
                                            rounded={1}
                                            hoverShadow="sm"
                                            shadow="sm"
                                            size="sm"
                                        >
                                            Salvar
                                        </Button>
                                    )}

                                </div>
                            </div>
                        </form>
                    </ModalBody>
                </>
            </Modal>
        </>
    )
}

export default ModalEditIntegrations